import React from "react";
import PropTypes from "prop-types";

// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Transitions
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ExitLiveDemo({ open, onClose, onConfirm, onExit }) {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            aria-describedby="exit-demo-dialog-slide-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: { borderRadius: "20px" } // Rounded corners
            }}
        >
            <DialogContent sx={{ p: 4, textAlign: "center" }}>

                {/* Header Message */}
                <MDBox mb={3}>
                    <MDTypography variant="h5" fontWeight="bold" gutterBottom color="dark">
                        Interested in seeing these features with your own data?
                    </MDTypography>
                    <MDTypography variant="body2" color="text" sx={{ opacity: 0.8, maxWidth: "90%", mx: "auto" }}>
                        Start a free trial to access these features using your own profile and your competitor's profile.
                    </MDTypography>
                </MDBox>

                {/* Dotted Border Box */}
                <MDBox
                    sx={{
                        border: "2px dashed #e0e0e0",
                        borderRadius: "16px",
                        padding: "32px",
                        backgroundColor: "#fcfcfc",
                        mb: 4
                    }}
                >

                    {/* Feature List (Styled Cards) */}
                    <MDBox
                        display="flex"
                        flexDirection="column"
                        gap={1.5}
                        mx="auto"
                        mb={3}
                        sx={{ maxWidth: "420px" }}
                    >
                        {[
                            {
                                icon: "insights",
                                color: "info",
                                title: "Own Profile Connection",
                                description: "Unlock detailed private insights for your accounts."
                            },
                            {
                                icon: "compare_arrows",
                                color: "secondary",
                                title: "Competitor Benchmarking",
                                description: "Compare your performance against key competitors."
                            },
                            {
                                icon: "pie_chart",
                                color: "warning",
                                title: "Deep Demographics",
                                description: "Break down your audience by age, gender, and location."
                            },
                            {
                                icon: "monetization_on",
                                color: "success",
                                title: "Organic & Paid Metrics",
                                description: "Track performance across all your traffic sources."
                            },
                            {
                                icon: "trending_up",
                                color: "error",
                                title: "Audience Growth",
                                description: "Monitor followers gained and lost over time."
                            },
                            {
                                icon: "visibility",
                                color: "primary",
                                title: "Reach & Impressions",
                                description: "Measure your brand's total visibility and impact."
                            }
                        ].map((feature, index) => (
                            <MDBox
                                key={index}
                                display="flex"
                                alignItems="center"
                                p={1.5}
                                borderRadius="lg"
                                border="1px solid #e0e0e0"
                                bgColor="white"
                                width="100%"
                            >
                                {/* Left Icon */}
                                <MDBox
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    width="2.5rem"
                                    height="2.5rem"
                                    borderRadius="lg"
                                    mr={2}
                                    sx={{
                                        backgroundColor: ({ palette: { [feature.color]: color }, functions: { rgba } }) => rgba(color.main, 0.1),
                                        color: ({ palette: { [feature.color]: color } }) => color.main,
                                    }}
                                >
                                    <Icon fontSize="medium">{feature.icon}</Icon>
                                </MDBox>

                                {/* Right Text */}
                                <MDBox display="flex" flexDirection="column" alignItems="flex-start" textAlign="left">
                                    <MDTypography variant="subtitle2" fontWeight="bold" color="text">
                                        {feature.title}
                                    </MDTypography>
                                    <MDTypography variant="caption" color="text" sx={{ opacity: 0.7, lineHeight: 1.2 }}>
                                        {feature.description}
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        ))}
                    </MDBox>

                    {/* Trust Badge Box (Teal Pill) */}
                    <MDBox
                        px={2}
                        py={0.5}
                        borderRadius="xl"
                        bgColor="rgba(0, 161, 161, 0.1)"
                        border="1px solid rgba(0, 161, 161, 0.3)"
                        display="inline-block"
                        width="auto"
                        textAlign="center"
                        mx="auto"
                    >
                        <MDTypography variant="caption" fontWeight="bold" sx={{ color: "#00A1A1" }}>
                            Free 14-Day Trial &bull; No Credit Card &bull; Cancel Anytime
                        </MDTypography>
                    </MDBox>
                </MDBox>

                {/* Action Buttons (Outside Box) */}
                <MDBox display="flex" flexDirection="column" gap={2} alignItems="center">

                    <MDButton
                        variant="gradient"
                        color="accent"
                        size="small"
                        onClick={onConfirm}
                        sx={{ px: 4, minWidth: "180px" }}
                    >
                        START FREE TRIAL
                    </MDButton>

                    <MDButton
                        variant="text"
                        color="secondary"
                        size="small"
                        onClick={onExit}
                        sx={{
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            color: "#999",
                            fontSize: "0.85rem"
                        }}
                    >
                        MAYBE LATER
                    </MDButton>
                </MDBox>
            </DialogContent>
        </Dialog>
    );
}

ExitLiveDemo.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onExit: PropTypes.func.isRequired,
};

export default ExitLiveDemo;
